export default {
  api: {
    item: '/api/item',
    matter: '/api/matter',
    entry: '/api/entry',
    task: '/api/item/task',
    calendar: '/api/item/calendar',
    settings: '/api/item/settings',
    account: '/api/Account',
    timesheet: '/api/timesheet',
    client: '/api/clients',
    quickbooks: '/api/quickbooks'
  },
  links: {
    tracker: 'https://chrome.google.com/webstore/detail/leanlaw-desktop/edceaokpechnlkiadlcimfjfnmdfjndf',
    gmail: 'https://chrome.google.com/webstore/detail/leanlaw-chrome-extension/deoiankojmgkbbepaabfhkadlbagjfdl',
    outlook: 'http://cloud.leanlaw.co/outlook/prod/setup.exe',
    ios: 'https://itunes.apple.com/us/app/leanlaw/id1128609356?ls=1&mt=8',
    android: 'https://play.google.com/store/apps/details?id=co.leanlaw.mobile',
    macTracker: 'https://s3-us-west-2.amazonaws.com/cloud.leanlaw.co/leanlaw.dmg',
    previewMacTracker: 'https://s3-us-west-2.amazonaws.com/cloud.leanlaw.co/leanlaw-dev.dmg',
    windowsTracker: 'https://s3-us-west-2.amazonaws.com/cloud.leanlaw.co/leanlaw.exe',
    previewWindowsTracker: 'https://s3-us-west-2.amazonaws.com/cloud.leanlaw.co/leanlaw-dev.exe'
  }
};